// export const updateValue = (state, payload) => {
//     state.value = payload
//   }

let mutations = {};

mutations.fn_countPhanHoi = (state) => {
    state.phanHoi.refreshFnCountNew++;
};

mutations.fn_countDichVuDiemDen = (state) => {
    state.dichVuDiemDen.refreshFnCountNew++;
};

mutations.fn_countDichVuLuuTru = (state) => {
    state.dichVuLuuTru.refreshFnCountNew++;
};

mutations.fn_countDichVuAmThuc = (state) => {
    state.dichVuAmThuc.refreshFnCountNew++;
};

mutations.fn_countDichVuGiaiTri = (state) => {
    state.dichVuGiaiTri.refreshFnCountNew++;
};

mutations.fn_countDichVuVeDienTu = (state) => {
    state.dichVuVeDienTu.refreshFnCountNew++;
};

mutations.fn_countDichVuVanTaiKhach = (state) => {
  state.dichVuVanTaiKhach.refreshFnCountNew++;
};

mutations.fn_countDiemDen = (state) => {
    state.diemDen.refreshFnCountNew++;
};

mutations.fn_countTourDuLich = (state) => {
    state.tourDuLich.refreshFnCountNew++;
};

mutations.fn_countLuuTru = (state) => {
    state.luuTru.refreshFnCountNew++;
};

mutations.fn_countAmThuc = (state) => {
    state.amThuc.refreshFnCountNew++;
};

mutations.fn_countGiaiTri = (state) => {
    state.giaiTri.refreshFnCountNew++;
};

mutations.fn_countVeDienTu = (state) => {
    state.veDienTu.refreshFnCountNew++;
};

mutations.fn_countVanTaiKhach = (state) => {
  state.veDienTu.refreshFnCountNew++;
};

mutations.fn_countQuangCao = (state) => {
    state.quangCao.refreshFnCountNew++;
};

mutations.fn_refreshMenu = (state) => {
    state.menu.refreshFnCount++;
};

mutations.fn_checkHaveDVCC = (state) => {
    state.check.checkDVCC++;
};

export default mutations;
